<div class="edit-page-root-container system-settings-edit-root-container" >
  <div class="page-content">
    <div class="page-header">
      <div class="page-title">
     <button mat-button class="nav-button" (click)="onBack()">
  <mat-icon>arrow_back</mat-icon>
        <span class="title">Attendance Export</span>
</button>
      </div>
      <div class="action-btn-container">
        <button mat-flat-button class="action-btn btn-discard" (click)="onExportAnyway()">Export Anyway</button>
        <button mat-flat-button class="action-btn  btn-save" (click)="copyTable()">Copy</button>
      </div>
    </div>
    <div class="page-details">
      <div class="detail-section general-settings">
        <div class="content-container">
<section tabindex="0" class="classic-table-container" >
  <!-- Summary Header (bold, outside table) -->
<div class="attendance-summary-header">
  <b>
    Payroll Group: {{ attendanceHeader?.payroll_group_code || proceedData?.data?.employee_attendance[0]?.p_code }}
    &nbsp; Year: {{ attendanceHeader?.year || proceedData?.data?.year }}
    &nbsp; Week: {{ attendanceHeader?.weekNo || proceedData?.data?.weekNo }}
    ({{ attendanceHeader?.start_date || groupedAttendance[0]?.noClockOut[0]?.start_date }}
    - {{ attendanceHeader?.end_date || groupedAttendance[0]?.noClockOut[0]?.end_date }})
  </b>
</div>

  <!-- Classic Bordered Table -->
<table #attendanceTable class="classic-attendance-table" *ngIf="groupedAttendance.length">
    <tr>
      <th colspan="4" class="main-title">Invalid Attendance Data</th>
    </tr>
    <tr>
      <th colspan="2" class="sub-title">
        Payroll Group : {{ proceedData.data.payroll_name || proceedData.data.employee_attendance[0]?.payroll_name }}
      </th>
      <th colspan="2" class="sub-title">
        Year {{ groupedAttendance[0]?.noClockOut[0]?.display_year || groupedAttendance[0]?.notFinalized[0]?.display_year }}
        Week {{ proceedData.data.weekNo }}
        ({{ groupedAttendance[0]?.noClockOut[0]?.start_date || groupedAttendance[0]?.notFinalized[0]?.start_date }}
        - {{ groupedAttendance[0]?.noClockOut[0]?.end_date || groupedAttendance[0]?.notFinalized[0]?.end_date }})
      </th>
    </tr>
    <ng-container *ngFor="let shop of groupedAttendance; let shopIdx = index">
      <tr>
        <td colspan="4" class="shop-header"><b>{{ shop.shopname }}</b></td>
      </tr>
      <!-- Attendance with no clock out -->
      <tr *ngIf="shop.noClockOut.length">
        <td></td>
        <td class="section-header"><b>Attendance with no clock out</b></td>
        <td></td>
        <td></td>
      </tr>
      <tr *ngFor="let emp of shop.noClockOut; let i = index">
        <td width="5%"></td>
        <td>{{ getRowNumber(shopIdx, i, 'noClockOut') }} {{ emp.f_name }} {{ emp.m_name }} {{ emp.l_name }}</td>
        <td>IN {{ emp.shift_start_date }} {{ emp.shift_start_time }}</td>
        <td></td>
      </tr>
      <!-- Staff not finalized -->
      <tr *ngIf="shop.notFinalized.length">
        <td></td>
        <td class="section-header"><b>Staff not finalized</b></td>
        <td></td>
        <td></td>
      </tr>
      <tr *ngFor="let emp of shop.notFinalized; let i = index">
        <td width="5%"></td>
        <td>{{ getRowNumber(shopIdx, i, 'notFinalized') }} {{ emp.f_name }} {{ emp.m_name }} {{ emp.l_name }}</td>
        <td>IN {{ emp.shift_start_date }} {{ emp.shift_start_time }}</td>
        <td>OUT {{ emp.shift_end_date }} {{ emp.shift_end_time }}</td>
      </tr>
    </ng-container>
  </table>
  <!-- <div *ngIf="!groupedAttendance.length" class="no-data-info">
   <p style="font-size: 18px; margin-top:20px;">The selected weekly attendance data is good for Export</p>
  </div> -->
</section>
        </div>
      </div>
    </div>
  </div>

</div>

